import { Badge } from "@/components/ui/badge";

const CONF = {
  "public": { label: "Public", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "interne": { label: "Interne", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  "confidentiel": { label: "Confidentiel", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  "très confidentiel": { label: "Très confidentiel", cls: "bg-red-50 text-crimson border-red-200" },
};

const SENS = {
  "faible": "bg-slate-100 text-slate-600 border-slate-200",
  "moyenne": "bg-amber-50 text-amber-700 border-amber-200",
  "élevée": "bg-red-50 text-red-700 border-red-200",
};

const STATUT = {
  "reçu": "bg-slate-100 text-slate-700",
  "qualifié": "bg-blue-100 text-blue-700",
  "en instruction": "bg-indigo-100 text-indigo-700",
  "décision": "bg-amber-100 text-amber-800",
  "transmis": "bg-violet-100 text-violet-700",
  "clôturé": "bg-emerald-100 text-emerald-700",
};

export function ConfidentialityBadge({ level, testid }) {
  const c = CONF[level] || CONF["interne"];
  return (
    <Badge data-testid={testid} variant="outline" className={`rounded-sm text-[10px] uppercase tracking-wide font-semibold ${c.cls}`}>
      {c.label}
    </Badge>
  );
}

export function SensitivityBadge({ level }) {
  const cls = SENS[level] || SENS["moyenne"];
  return (
    <Badge variant="outline" className={`rounded-sm text-[10px] uppercase tracking-wide ${cls}`}>
      Sens. {level}
    </Badge>
  );
}

export function StatusBadge({ statut }) {
  const cls = STATUT[statut] || "bg-slate-100 text-slate-700";
  return <span className={`rounded-sm px-2 py-0.5 text-[11px] font-medium ${cls}`}>{statut}</span>;
}

// Deterministic color per agent key for geometric avatars
const PALETTE = ["#002664", "#0f766e", "#b45309", "#9d174d", "#1e40af", "#3730a3", "#065f46", "#7c2d12"];
export function agentColor(key) {
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) % PALETTE.length;
  return PALETTE[h];
}

export function AgentAvatar({ agentKey, size = 40 }) {
  const color = agentColor(agentKey);
  const initials = agentKey.replace(/[^A-Z]/g, "").slice(0, 2) || agentKey.slice(0, 2).toUpperCase();
  return (
    <div
      className="flex items-center justify-center rounded-sm font-mono font-semibold text-white shrink-0"
      style={{ width: size, height: size, background: color, fontSize: size * 0.34 }}
    >
      {initials}
    </div>
  );
}
